import React from 'react';
import { Facebook, Twitter, Linkedin, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import LanguageSelector from './LanguageSelector';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Sustainalyze</h3>
            <p className="text-gray-400">{t('footer.aboutText')}</p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">{t('footer.solutions')}</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white">ESG Reporting</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Carbon Management</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Supply Chain ESG</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">{t('footer.company')}</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white">About Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Blog</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Careers</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-white">{t('footer.contact')}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Resources</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">{t('footer.contact')}</h4>
            <div className="flex space-x-4 mb-4">
              <a href="#" className="text-gray-400 hover:text-white">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#contact" className="text-gray-400 hover:text-white" aria-label={t('footer.contact')}>
                <Mail className="h-5 w-5" />
              </a>
            </div>
            <p className="text-gray-400">
              hello@sustainalyze.app<br />
              +1 (555) 123-4567
            </p>
            <div className="mt-4">
              <LanguageSelector />
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">{t('footer.rights')}</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/privacy" className="text-gray-400 hover:text-white text-sm">{t('footer.privacy')}</a>
              <a href="/kvkk" className="text-gray-400 hover:text-white text-sm">{t('footer.kvkk')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
